"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const LinearProgress_1 = tslib_1.__importDefault(require("@mui/material/LinearProgress"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 *
 * @category component
 */
const TechnicalContent = ({ aggregatedError, argusRequestId }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, !aggregatedError ? (react_1.default.createElement(LinearProgress_1.default, { sx: { width: "100%" }, color: "secondary" })) : (react_1.default.createElement(Grid_1.default, { container: true, direction: "column" },
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "h6", display: "inline" }, "Technical information")),
        argusRequestId && (react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", display: "inline" }, `Argus-Request-ID: `),
            react_1.default.createElement(Typography_1.default, { variant: "body2", display: "inline" }, argusRequestId))),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", display: "inline" }, `URL: `),
            react_1.default.createElement(Typography_1.default, { variant: "body2", display: "inline" }, aggregatedError.url)),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", display: "inline" }, `Timestamp: `),
            react_1.default.createElement(Typography_1.default, { variant: "body2", display: "inline" }, aggregatedError.timestamp)),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", display: "inline" }, `Environment: `),
            react_1.default.createElement(Typography_1.default, { variant: "body2", display: "inline" }, aggregatedError.environment)),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: { whiteSpace: "pre" } }, "Error stack:")),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "caption", sx: { whiteSpace: "pre" } }, aggregatedError.mappedErrorStack))))));
};
exports.default = TechnicalContent;
